import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import React from "react";
import { Controller } from "react-hook-form";
import Select, { components, StylesConfig } from "react-select";
import { ControlProps, SelectOption } from "types";
import ErrorMessage from "../error-message/error-message";
import "./select-control.scss";

interface SelectControlProps extends ControlProps {
	placeholder?: string;
	items?: SelectOption[];
	onChange?: (selectedOption?: string) => void;
}

const customStyles: StylesConfig<any, any, any> = {
	valueContainer: (provided: any, state: any) => ({
		...provided,
		overflow: "visible"
	}),
	placeholder: (base: any, state: any) => ({
		...base,
		position: "absolute",
		top:
			(state.hasValue || state.selectProps.inputValue)
				? "-50%"
				: "0%",
		transition: "top 0.2s",
		fontSize:
			(state.hasValue || state.selectProps.inputValue) ? "11.5px" : "15px",
		fontFamily:
			(state.hasValue || state.selectProps.inputValue) ? "GothamBook" : "GothamMedium",
		paddingTop:
			(state.hasValue || state.selectProps.inputValue) ? "0" : "8px",
	})
};

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }: any) => {
	return (
		<ValueContainer {...props}>
			<Placeholder {...props} isFocused={props.isFocused}>
				{props.selectProps.placeholder}
			</Placeholder>
			{React.Children.map(children, child =>
				child && child.key !== "placeholder" ? child : null
			)}
		</ValueContainer>
	);
};

const SelectControl = (props: SelectControlProps) => {
	const { control, formState: { errors } } = props.formMethods ?? { formState: {} };

	const rules: any = {};
	if (props.required) {
		rules.validate = (value?: any) => (isNil(value) || isEmpty(value)) ? "Dato requerido" : true;
	}

	return (
		<div>
			<Controller
				name={props.name}
				control={control}
				rules={rules}
				defaultValue={""}
				render={({ field }) => {
					return (
						<Select
							classNamePrefix="select-input"
							className={`${(errors?.[props.name]) ? "is-invalid select-input-container" : "select-input-container"}`}
							placeholder={props.placeholder ?? props.label}
							components={{
								ValueContainer: CustomValueContainer
							}}
							options={props.items ?? []}
							tabIndex={props.tabIndex}
							value={props.items?.find(item => item.value === field.value) ?? null}
							onChange={value => {
								const selectedOption = value?.value;
								field.onChange(selectedOption);
								if (props.onChange) {
									props.onChange(selectedOption);
								}
							}}
							styles={customStyles}
						/>
					);
				}}
			/>
			<ErrorMessage error={errors?.[props.name]} />
		</div>
	);
};

export default SelectControl;